"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountFormSchema = exports.AccountSchema = exports.TwilioWhatsappConfigModalSchema = exports.TwilioWhatsappConfigSchema = exports.ScoutFeedbackRating = exports.PromotionStatus = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const delivery_model_1 = require("./delivery.model");
const language_model_1 = require("./language.model");
const product_model_1 = require("./product.model");
const lexbot_model_1 = require("./lexbot.model");
const feature_model_1 = require("./feature.model");
const state_model_1 = require("./state.model");
const region_model_1 = require("./region.model");
const account_intent_model_1 = require("../schema/account-intent.model");
const account_slot_model_1 = require("../schema/account-slot.model");
const locale_model_1 = require("./locale.model");
const account_services_model_1 = require("../schema/account-services.model");
const constants_1 = require("../constants");
const phonereg = /^[0-9]{3,14}$/;
const twilioAccountSidRegex = /^[A-Za-z0-9]{34}$/;
const twilioAuthTokenRegex = /^[A-Za-z0-9]{32}$/;
const colorHexCode = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
var PromotionStatus;
(function (PromotionStatus) {
    PromotionStatus["NOT_STARTED"] = "not_started";
    PromotionStatus["IN_PROGRESS"] = "in_progress";
    PromotionStatus["COMPLETED"] = "completed";
    PromotionStatus["FAILED"] = "failed";
})(PromotionStatus || (exports.PromotionStatus = PromotionStatus = {}));
var ScoutFeedbackRating;
(function (ScoutFeedbackRating) {
    ScoutFeedbackRating["THUMBS_UP"] = "thumbs_up";
    ScoutFeedbackRating["THUMBS_DOWN"] = "thumbs_down";
})(ScoutFeedbackRating || (exports.ScoutFeedbackRating = ScoutFeedbackRating = {}));
const keyValuePairSchema = yup_lib_1.default.object({
    keyValues: yup_lib_1.default.array().of(yup_lib_1.default.object().shape({
        key: yup_lib_1.default.string().required('Key is required'),
        value: yup_lib_1.default.string().required('Value is required')
    }))
});
exports.TwilioWhatsappConfigSchema = yup_lib_1.default.object().shape({
    number: yup_lib_1.default
        .string()
        .required()
        .matches(phonereg, 'Please enter a numeric value between 3 and 14 digits long')
        .label('Twilio Whatsapp Number'),
    twilioAccountSid: yup_lib_1.default
        .string()
        .required()
        .matches(twilioAccountSidRegex, 'It should be 34 characters long')
        .label('Twilio Account Sid'),
    twilioAuthToken: yup_lib_1.default
        .string()
        .required()
        .matches(twilioAuthTokenRegex, 'It should be 32 characters long')
        .label('Twilio Auth Token')
});
exports.TwilioWhatsappConfigModalSchema = yup_lib_1.default.object().shape({
    localNumbers: yup_lib_1.default
        .array()
        .of(exports.TwilioWhatsappConfigSchema)
        .min(1, 'At least one Twilio WhatsApp Number is required')
});
exports.AccountSchema = yup_lib_1.default.object().shape({
    clientName: yup_lib_1.default
        .string()
        .required()
        .max(50, 'Must be maximum of 50 character')
        .matches(constants_1.nameRegex, constants_1.TEXT_AREA_VALIDATION_MSG)
        .label('Client Name'),
    state: state_model_1.accountStateSchema,
    city: yup_lib_1.default.string().required().label('City').matches(constants_1.cityRegex, constants_1.TEXT_AREA_VALIDATION_MSG),
    region: region_model_1.accountRegionSchema,
    serviceName: yup_lib_1.default.string().max(30, 'Must be maximum of 30 character').label('Service Name'),
    number: yup_lib_1.default
        .string()
        .matches(phonereg, 'Please enter a numeric value between 3 and 14 digits long')
        .required()
        .label('Phone Number'),
    usedLexBot: lexbot_model_1.accountLexBotSchema,
    products: yup_lib_1.default.array().of(product_model_1.accountProductSchema).min(1).required().label('Products'),
    features: yup_lib_1.default.array().of(feature_model_1.accountFeatureSchema).min(1).notRequired().label('Features'),
    clientAdmins: yup_lib_1.default.string().notRequired().label('Client Admins'),
    alertCategories: yup_lib_1.default.string().notRequired().label('Alert Categories'),
    greetingCopy: yup_lib_1.default
        .string()
        .when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().required()
    })
        .matches(constants_1.noHtmlRegex, constants_1.HTML_VALIDATION_ERROR)
        .label('Greeting Copy'),
    webChatDesignElements: yup_lib_1.default.string().notRequired(),
    languages: yup_lib_1.default.array().of(language_model_1.accountLanguageSchema).notRequired().label('Language'),
    intents: yup_lib_1.default.array().of(account_intent_model_1.AccountIntentSchema).max(1000).notRequired(),
    services: yup_lib_1.default.array().of(account_services_model_1.AccountServiceModelSchema).notRequired(),
    deliveries: yup_lib_1.default.array().of(delivery_model_1.deliverySchema).notRequired(),
    lexBotInfo: yup_lib_1.default.object().notRequired().label('Lex bot Info'),
    slotTypes: yup_lib_1.default.array().of(account_slot_model_1.AccountSlotSchema).max(250).notRequired(),
    botDescription: yup_lib_1.default
        .string()
        .required()
        .max(100, 'Must be maximum of 100 character')
        .matches(constants_1.noHtmlRegex, constants_1.HTML_VALIDATION_ERROR)
        .label('Bot Description'),
    isChildDirected: yup_lib_1.default.boolean().required().label('Is Child Directed'),
    idleSessionTTLInSeconds: yup_lib_1.default.number().required().label('Idle Session TTL'),
    nluConfidenceThreshold: yup_lib_1.default.number().min(0).max(1).required().label('NLU COnfidence Threshold'),
    locales: yup_lib_1.default.array().of(locale_model_1.LocaleCodeTypeSchema).min(1).required().label('Locales'),
    scoutAgentId: yup_lib_1.default.string().notRequired().label('Scout Agent Id'),
    scoutTurboAppId: yup_lib_1.default
        .string()
        .notRequired()
        .max(50, 'Must be maximum of 50 character')
        .matches(constants_1.scoutTurboAppIdRegex, constants_1.SCOUT_VALIDATION_ERROR)
        .label('Scout Turbo Id'),
    scoutWorkflowId: yup_lib_1.default
        .string()
        .notRequired()
        .test('is-valid-length-or-empty', constants_1.SCOUT_WORKFLOW_VALIDATION_ERROR, value => !value || constants_1.scoutWorkflowIdRegex.test(value))
        .label('Scout Workflow Id'),
    logoImgUrl: yup_lib_1.default.string().required().label('Bot Avatar Image'),
    chatOpenningImgUrl: yup_lib_1.default.string().required().label('Chat Open Icon Image'),
    chatCloseImgUrl: yup_lib_1.default.string().required().label('Chat Close Icon Image'),
    botProfileImgUrl: yup_lib_1.default.string().required().label('Bot Logo Image'),
    chatWidgetTitle: yup_lib_1.default
        .string()
        .when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().required().max(30, 'Must be maximum of 30 character')
    })
        .matches(constants_1.noHtmlRegex, constants_1.HTML_VALIDATION_ERROR)
        .label('Chat Widget Title'),
    chatWidgetSubTitle: yup_lib_1.default
        .string()
        .when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().max(30, 'Must be maximum of 30 character')
    })
        .matches(constants_1.noHtmlRegex, constants_1.HTML_VALIDATION_ERROR)
        .label('Chat Widget Subtitle'),
    headerBackgroundColor: yup_lib_1.default
        .string()
        .when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().matches(colorHexCode, 'Please enter color Hex Code').required()
    })
        .label('Header Background Colour'),
    headerTextColor: yup_lib_1.default
        .string()
        .when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().matches(colorHexCode, 'Please enter color Hex Code').required()
    })
        .label('Header Text Colour'),
    messageBackgroundColor: yup_lib_1.default
        .string()
        .when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().matches(colorHexCode, 'Please enter color Hex Code').required()
    })
        .label('Message Background Colour'),
    messageTextColor: yup_lib_1.default
        .string()
        .when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Web chat');
        },
        then: yup_lib_1.default.string().matches(colorHexCode, 'Please enter color Hex Code').required()
    })
        .label('Message Text Colour'),
    enableMessageButton: yup_lib_1.default.boolean().notRequired(),
    multilingual: yup_lib_1.default.boolean().notRequired(),
    isAllowAnonymous: yup_lib_1.default.boolean().notRequired(),
    customEndingMessage: yup_lib_1.default.string().nullable().label('Custom Ending Message'),
    customMessages: yup_lib_1.default.object().optional().label('Custom Error message'),
    enableMessageButtonOnFailure: yup_lib_1.default.boolean().notRequired(),
    isTestBot: yup_lib_1.default.boolean().notRequired(),
    smsGreeting: yup_lib_1.default
        .string()
        .when(['products'], {
        is: (products) => {
            return products === null || products === void 0 ? void 0 : products.some(elem => elem === 'Text chat');
        },
        then: yup_lib_1.default.string().required()
    })
        .matches(constants_1.noHtmlRegex, constants_1.HTML_VALIDATION_ERROR)
        .label('Sms greeting'),
    isSynced: yup_lib_1.default.boolean().notRequired(),
    lastUpdated: yup_lib_1.default.date().notRequired(),
    liveChat: yup_lib_1.default.boolean().notRequired(),
    promotionStatus: yup_lib_1.default
        .mixed()
        .oneOf(Object.values(PromotionStatus))
        .notRequired()
        .label('Promotion Status'),
    isPoweredByHidden: yup_lib_1.default.boolean().notRequired(),
    isPhotoUpload: yup_lib_1.default.boolean().notRequired(),
    allowScoutFeedback: yup_lib_1.default.boolean().notRequired(),
    scoutFeedbackMessage: yup_lib_1.default
        .string()
        .when('allowScoutFeedback', {
        is: true,
        then: yup_lib_1.default.string().required().label('Scout Feedback Message')
    })
        .label('Scout Feedback Message'),
    chatbotFeedbackResponse: yup_lib_1.default
        .string()
        .when('allowScoutFeedback', {
        is: true,
        then: yup_lib_1.default.string().required().label('Chatbot Feedback Response')
    })
        .label('Chatbot Feedback Response'),
    scoutFeedbackDefaultRating: yup_lib_1.default
        .mixed()
        .notRequired()
        .when('allowScoutFeedback', {
        is: true,
        then: yup_lib_1.default
            .mixed()
            .oneOf(Object.values(ScoutFeedbackRating))
            .required()
            .label('Scout Feedback Default Rating')
    })
        .label('Scout Feedback Default Rating'),
    isApiIntegrationEnabled: yup_lib_1.default.boolean().notRequired(),
    apiKey: yup_lib_1.default.string().notRequired(),
    allowWhatsappIntegration: yup_lib_1.default.boolean().notRequired(),
    twilioWhatsappNumbers: yup_lib_1.default.array().when('allowWhatsappIntegration', {
        is: true,
        then: yup_lib_1.default
            .array()
            .of(exports.TwilioWhatsappConfigSchema)
            .required('Twilio Whatsapp Number is required')
            .min(1, 'At least one Twilio number must be provided'),
        otherwise: yup_lib_1.default.array().notRequired()
    }),
    customizeIconSize: yup_lib_1.default.boolean().notRequired().label('Customize Icon Size'),
    iconSize: yup_lib_1.default
        .number()
        .when('customizeIconSize', {
        is: true,
        then: schema => schema
            .required('Icon size is required when customization is enabled.')
            .min(80, 'Icon size must be at least 80px.')
            .max(200, 'Icon size must not exceed 200px.'),
        otherwise: schema => schema.notRequired()
    })
        .typeError('Icon size must be a valid number.')
        .label('Icon Size'),
    rightPad: yup_lib_1.default
        .number()
        .typeError('Right Padding must be a valid number.')
        .min(0, 'Right Padding must be at least 0px.')
        .max(500, 'Right Padding must not exceed 500px.')
        .notRequired()
        .label('Right Padding'),
    leftPad: yup_lib_1.default
        .number()
        .typeError('Left Padding must be a valid number.')
        .min(0, 'Left Padding must be at least 0px.')
        .max(500, 'Left Padding must not exceed 500px.')
        .notRequired()
        .label('Left Padding'),
    alignChatIconToLeft: yup_lib_1.default.boolean().notRequired().label('Align Chat Icon to Left')
});
exports.AccountFormSchema = exports.AccountSchema.concat(keyValuePairSchema);
